// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3nXDt","selected":"Chip_selected__24rGG"};